module.exports = __webpack_public_path__ + "static/Pheonix-5d636bd0d15fc4d90aa9b265987ce3c8.jpg";